import { render } from "./OccupationMaritalStatusInfo.vue.ts?vue&type=template&id=a9b57c3e&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OccupationMaritalStatusInfo.vue?vue&type=template&id=a9b57c3e&ts=true"
import script from "./OccupationMaritalStatusInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OccupationMaritalStatusInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./OccupationMaritalStatusInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OccupationMaritalStatusInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/customer-registration/customer-contact-info/countries-extra-info/OccupationMaritalStatusInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9b57c3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9b57c3e', __exports__)) {
    api.reload('a9b57c3e', __exports__)
  }
  
  module.hot.accept("./OccupationMaritalStatusInfo.vue.ts?vue&type=template&id=a9b57c3e&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OccupationMaritalStatusInfo.vue?vue&type=template&id=a9b57c3e&ts=true", () => {
    api.rerender('a9b57c3e', render)
  })

}


export default __exports__